module.exports = __webpack_public_path__ + "static/ian-7df2e81fc5099d309499be64cd06bebf.png";